import React, { useContext, useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import Layout from '../../product/components/templates/Layout'
import CustomTable from '../../product/components/molecules/CustomTable'
import CustomSearch from '../../product/components/molecules/CustomSearch'
import { handleRedirectInternal } from '../../product/common/components'
import { useFormik } from 'formik'
import AlertContext from '../../product/context/alert/alertContext'
import CommunicationContext from '../../product/context/communication/communicationContext'
import SettingContext from '../../product/context/setting/settingContext'
import { Button, Dialog } from '@mui/material'
import Loaders from '../../product/components/molecules/Loaders'

const SubscribeInfo = (props) => {
    const alertContext = useContext(AlertContext)
    const communicationContext = useContext(CommunicationContext)
    const settingcontext = useContext(SettingContext)

    const history = useHistory()
    const [isLoading, setIsLoading] = useState(true)
    const { setAlert } = alertContext
    const {
        all_templates,
        getAllSearchTemplates,
        responseStatus: responseStatusCommuncation,
        clearResponse: clearResponseCommuncation,
    } = communicationContext
    const {
        searchTableAction,
        searchTable,
        table_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseSetting,
    } = settingcontext
    const [manage, setManage] = React.useState({
        popup: false,
        status: 'new',
        id: 0,
        action: '',
    })

    let action = props.match.params.action

    const toggleFullScreenPopup = (popup, status, id) => {
        if (popup) {
            setManage({ popup, status, id, action: action })
        } else {
            setManage({ popup, status: 'new', id: 0, action: action })
        }
    }

    const [messageModal, setMessageModal] = useState({
        popup: false,
        id: 0,
    })

    const [tableBody, setTableBody] = useState([])
    const formik = useFormik({
        initialValues: {
            action: action,
            searchterm: '',
            page: 1,
            limit: 20,
            count: 1,
            order: '',
            orderby: '',
            filters: {
                email: {
                    value: '',
                    type: 'like',
                    field: 'cou.email',
                },
            },
            table: 'contact_us',
        },
        onSubmit: (values) => {
            console.log(values, 'lllpppppppp')
            // values.filters.email.value = values.email
            setIsLoading(true)
            searchTable(values)
        },
    })
    useEffect(() => {
        formik.handleSubmit()
        return () => {
            formik.values.filters.email.value = ''
        }
    }, [])

    useEffect(() => {
        if (table_data && table_data.records) {
            setTableBody(table_data.records.length ? table_data.records : [])
            setIsLoading(false)
        }
    }, [table_data])

    const onClickEdit = (id) => {
        setMessageModal({ popup: true, id: id })
    }
    useEffect(() => {
        setTableBody([])
        setIsLoading(true)
        formik.values.action = action
        formik.values.page = 1
        formik.values.searchterm = ''
        //getAllSearchTemplates(formik.values)
        searchTable(formik.values)
        /*  return () => {
            setTableBody([])
        }*/
    }, [action])

    const tableValues = [
        // {
        //     field: 'first_name',
        //     type: '',
        //     firstChild: true,
        //     sort: true,
        //     disablePadding: false,
        //     label: 'Name',
        //     filterable: true,
        //     filterField: 'cou.first_name',
        // },
        {
            field: 'email',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Email',
            filterable: true,
            filterField: 'cou.email',
        },
        // {
        //     field: 'phone',
        //     type: '',
        //     firstChild: false,
        //     sort: true,
        //     disablePadding: false,
        //     label: 'Phone number',
        //     filterable: true,
        //     filterField: 'cou.phone',
        // },
        // {
        //     field: 'company_name',
        //     type: '',
        //     firstChild: false,
        //     sort: true,
        //     disablePadding: false,
        //     label: 'Company Name',
        //     filterable: true,
        //     filterField: 'cou.company_name',
        // },
        // {
        //     field: 'job_title',
        //     type: '',
        //     firstChild: false,
        //     sort: true,
        //     disablePadding: false,
        //     label: 'Job Title',
        //     filterable: true,
        //     filterField: 'cou.job_title',
        // },
        // {
        //     field: 'customer_type',
        //     type: '',
        //     firstChild: false,
        //     sort: true,
        //     disablePadding: false,
        //     label: 'customer type',
        //     filterable: true,
        //     filterField: 'cou.customer_type',
        // },
        {
            field: 'message',
            firstChild: false,
            sort: false,
            onclick: onClickEdit,
            type: 'hyperlink',
            clickID: 'id',
            // tooltiptitle: 'View full message',
            disablePadding: false,
            label: 'Message',
            filterable: true,
            filterField: 'cou.message',
        },
        {
            field: 'created_at',
            type: 'datetime',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Created At',
        },
    ]

    const searchInfo = [
        {
            label: 'Email',
            placeholder: 'Enter Email',
            class: 'col-md-4 col-sm-6 col-12',
            type: 'text',
            name: 'email',
            filter: true,
            formik: formik,
        },
    ]

    return (
        <Layout>
            <div className="dashboard communications">
                <CustomSearch searchInfo={searchInfo} formik={formik} />
                <CustomTable
                    formik={formik.values}
                    tableBody={tableBody}
                    tableValues={tableValues}
                    tableActions={[]}
                    allData={table_data}
                    isLoading={isLoading}
                    loadingTemplate={'table'}
                    changeTableFunction={searchTable}
                />
                <Dialog
                    className="contactModal"
                    open={messageModal.popup}
                    onClose={() => setMessageModal({ popup: false, id: 0 })}
                >
                    <div className="contactModalCnt">
                        <Button
                            className="closeIcon"
                            onClick={() =>
                                setMessageModal({ popup: false, id: 0 })
                            }
                        >
                            <span className="material-icons">close</span>
                        </Button>
                        <div className="contactModalInner">
                            <h4>Message:</h4>
                            <p>
                                {
                                    tableBody
                                        .filter(
                                            (msg) => msg.id == messageModal.id
                                        )
                                        .map((data) => data.message)[0]
                                }
                            </p>
                        </div>
                    </div>
                </Dialog>
            </div>
        </Layout>
    )
}
export default SubscribeInfo
